/* eslint-disable */
import React from 'react';
import {isMacLike} from '../../helpers/device-recognition';

const ShareIcon = props => {
  if (isMacLike) {
    return (
      <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M11.168 15H13.168V9H16.168L12.168 4L8.16797 9H11.168V15Z" fill="#212121" />
        <path d="M20.168 18H4.16797V11H2.16797V18C2.16797 19.103 3.06497 20 4.16797 20H20.168C21.271 20 22.168 19.103 22.168 18V11H20.168V18Z" fill="#212121" />
      </svg>
    );
  }

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M3 12C3 13.654 4.346 15 6 15C6.794 15 7.512 14.685 8.049 14.18L14.04 17.604C14.022 17.734 14 17.864 14 18C14 19.654 15.346 21 17 21C18.654 21 20 19.654 20 18C20 16.346 18.654 15 17 15C16.206 15 15.488 15.315 14.951 15.82L8.96 12.397C8.978 12.266 9 12.136 9 12C9 11.864 8.978 11.734 8.96 11.603L14.951 8.18C15.488 8.685 16.206 9 17 9C18.654 9 20 7.654 20 6C20 4.346 18.654 3 17 3C15.346 3 14 4.346 14 6C14 6.136 14.022 6.266 14.04 6.397L8.049 9.82C7.496 9.29468 6.76273 9.00123 6 9C4.346 9 3 10.346 3 12Z" fill="#212121"/>
    </svg>
  );
}

export {ShareIcon};
